export var flatMapOptions = function (options) {
    return options.flatMap(function (option) {
        if ("options" in option) {
            return option.options;
        }
        return [option];
    });
};
export var getOptionElementToSelect = function (value) {
    if (document.querySelector('li[data-value="' + value + '"]')) {
        return document.querySelector('li[data-value="' + value + '"]');
    }
    return undefined;
};
export var changeOptionToFocus = function (allOptions, value, modifier) {
    var positionOfActualOption = allOptions.findIndex(function (element) { return element.value === value; });
    return moveToNOptions(allOptions, positionOfActualOption + modifier, modifier);
};
export var moveToNOptions = function (allOptions, nInitial, nModifier) {
    var nbElements = allOptions.length;
    var indexFocus = nInitial - nModifier;
    do {
        indexFocus += nModifier;
        if (indexFocus >= nbElements) {
            indexFocus = 0;
        }
        else if (indexFocus < 0) {
            indexFocus = nbElements - 1;
        }
    } while (allOptions[indexFocus].disabled);
    return getOptionElementToSelect(allOptions[indexFocus].value);
};
